"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntaxFactory = void 0;
const atom_1 = require("./nodes/atom");
const binary_operation_1 = require("./nodes/binary-operation");
const collection_1 = require("./nodes/collection");
const unary_operation_1 = require("./nodes/unary-operation");
const syntax_kind_1 = require("./syntax-kind");
class SyntaxFactory {
    static And(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.AndOperation, left, right);
    }
    static Or(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.OrOperation, left, right);
    }
    static Not(operand) {
        return new unary_operation_1.UnaryOperation(syntax_kind_1.SyntaxKind.NotOperation, operand);
    }
    static Equal(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.EqualOperation, left, right);
    }
    static NotEqual(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.NotEqualOperation, left, right);
    }
    static GreaterThan(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.GreaterThanOperation, left, right);
    }
    static GreaterThanOrEqual(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.GreaterThanOrEqualOperation, left, right);
    }
    static LessThan(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.LessThanOperation, left, right);
    }
    static LessThanOrEqual(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.LessThanOrEqualOperation, left, right);
    }
    static MatchOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.MatchOperation, left, right);
    }
    static NotMatchOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.NotMatchOperation, left, right);
    }
    static SubsetOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.SubsetOperation, left, right);
    }
    static NotSubsetOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.NotSubsetOperation, left, right);
    }
    static SupersetOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.SupersetOperation, left, right);
    }
    static NotSupersetOperation(left, right) {
        return new binary_operation_1.BinaryOperation(syntax_kind_1.SyntaxKind.NotSupersetOperation, left, right);
    }
    static Boolean(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.BooleanLiteral, token);
    }
    static Collection(elements) {
        return new collection_1.Collection(elements);
    }
    static Date(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.DateLiteral, token);
    }
    static Null(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.NullLiteral, token);
    }
    static Number(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.NumberLiteral, token);
    }
    static RegExp(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.RegExpLiteral, token);
    }
    static String(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.StringLiteral, token);
    }
    static Uuid(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.UuidLiteral, token);
    }
    static Identifier(token) {
        return new atom_1.Atom(syntax_kind_1.SyntaxKind.Identifier, token);
    }
}
exports.SyntaxFactory = SyntaxFactory;
//# sourceMappingURL=syntax-factory.js.map